/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file buildStateUpdater internal helper function
 * @author Roland Scott
 * @module react-async-hook\internal\use-async\build-state-updater
 */

import { Dispatch } from "react";
import { IAction } from "../";

/**
 * Build the function that will update the async state
 * @param dispatch The dispatch function from useReducer
 */
export function buildStateUpdater(dispatch: Dispatch<IAction>): (action: IAction) => void {
	return action => {
		dispatch(action);
	};
}
